import React, {useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Link} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {Link as UrlLink} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Fab from '@material-ui/core/Fab';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import AddIcon from '@material-ui/icons/Add';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(1, 0)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: theme.spacing(5)
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide {...props} direction='up' />;
});

const defaultFilter = {
  idBranch: '0',
  text: '',
  showExtendedInfo: false,
  showDeletedItems: false
};

export default function Registers(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState(defaultFilter);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemOperation, setSelectedItemOperation] = useState(null);
  const [selectedItemWarning, setSelectedItemWarning] = useState(null);

  const fullScreen = useMediaQuery(useTheme().breakpoints.down('xs'));

  useEffect(() => {
    setIsLoaded(false);
    ajax('getRegisters')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const handleSelectedItemChange = e => {
    setSelectedItem({
      ...selectedItem,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  useEffect(() => {
    if (selectedItem === null || selectedItemOperation === null)
      return;

    var warning = null;
    switch (selectedItemOperation) {
      case 'editRegister':
        warning = warning === null ? selectedItem.register.length < 6 ? 'Numele registrului este prea scurt' : null : warning;
        break;

      default:
        break;
    }

    setSelectedItemWarning(warning);
  }, [data, selectedItem, selectedItemOperation]);

  const filterData = item => true
      && (filter.idBranch === '0' || item.idBranch === filter.idBranch)
      && (
           !!~item.register.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.year.indexOf(filter.text.toLowerCase())
      )
      && ((!filter.showDeletedItems && item.deletedBy === null) || (filter.showDeletedItems && item.deletedBy !== null));

  const handleItemMenuOpen = item => e => {
    setSelectedItem(item);
    setAnchorEl(e.currentTarget);
  };
  const handleItemMenuClick = operation => () => {
    setAnchorEl(null);
    setSelectedItemOperation(operation);
  };
  const handleItemMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
    setSelectedItemOperation(null);
  };

  const handleEditRegister = () => {
    setIsLoaded(false);
    ajax('saveRegister', selectedItem)
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleDeleteRegister = () => {
    setIsLoaded(false);
    ajax('markRegisterAsDeleted', {
      idRegister: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleUndeleteRegister = () => {
    setIsLoaded(false);
    ajax('markRegisterAsUndeleted', {
      idRegister: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Registre</Typography>
      <Typography variant='subtitle2'>Administrare registre.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.registers.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.registers.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' select
              label='Punct de lucru'
              placeholder='Punct de lucru'
              name='idBranch'
              value={filter.idBranch}
              onChange={handleFilterChange}
            >
              <MenuItem key='0' value='0'>Toate punctele de lucru</MenuItem>
              {data.branches.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.branch}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showExtendedInfo'
                  checked={filter.showExtendedInfo}
                  value={filter.showExtendedInfo}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza informatii extinse'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showDeletedItems'
                  checked={filter.showDeletedItems}
                  value={filter.showDeletedItems}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza registrele sterse'
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.registers.length > 0 && data.registers.filter(filterData).length === 0 &&
        <Box>
          <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
          <Typography color='primary' align='center'>Daca v-ati pierdut, incercati resetarea filtrelor de <UrlLink href='#' color='initial' onClick={() => setFilter(defaultFilter)}>aici</UrlLink></Typography>
        </Box>
      }

      {isLoaded &&
        <List dense>
          {data.registers.filter(filterData).map((item, i, a) =>
            <Fragment key={item.id}>
              {(i === 0 || a[i].branch !== a[i - 1].branch || a[i].year !== a[i - 1].year) &&
                <ListSubheader color='primary' disableSticky>{item.branch} - {item.year ? `doar pentru anul ${item.year}` : 'pentru orice an'}</ListSubheader>
              }

              <ListItem dense button className={classes.listItemDense}
                selected={selectedItem && item.id === selectedItem.id}
                onClick={() => {
                  setSelectedItem(item);
                  setSelectedItemOperation('editRegister');
                }}
              >
                <ListItemText className={classes.listItemTextDense} disableTypography
                  primary={
                    <Typography style={{fontWeight: 'bold'}}>{item.register} {item.year ? `(doar pentru anul ${item.year})` : ''}</Typography>
                  }
                  secondary={
                    <Box>
                      <Typography component='span' display='inline' color='textSecondary'>
                        Ultimul numar alocat:
                        <Typography display='inline' color='textPrimary'>{` ${item.lastNumber}`}</Typography>
                      </Typography>
                      {filter.showExtendedInfo &&
                        <Box>
                          <Typography color='secondary'>Sa afisam si registrul (contorul) pentru facturi (tot pe punct de lucru si an)</Typography>
                          <Typography color='textSecondary'>
                            {`Creat de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdBy}</Typography>
                            {` la data de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdAt}</Typography>
                          </Typography>
                        </Box>
                      }
                      {item.deletedBy &&
                        <Typography color='secondary'>{`Sters de ${item.deletedBy} la data de ${item.deletedAt}`}</Typography>
                      }
                      <Typography variant='caption' color='textSecondary' display='block' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.description}</Typography>
                    </Box>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge='end'
                    onClick={handleItemMenuOpen(item)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </Fragment>
          )}
        </List>
      }

      <Menu keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleItemMenuClose}
      >
        <MenuItem divider={false} onClick={handleItemMenuClick('editRegister')}>
          <ListItemIcon className={classes.listItemIcon}><EditIcon fontSize='small' /></ListItemIcon>
          <Typography variant='body1' style={{fontWeight: 'bold'}}>Modifica</Typography>
        </MenuItem>

        {selectedItem && !selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('deleteRegister')}>
            <ListItemIcon className={classes.listItemIcon}><DeleteIcon fontSize='small' color='secondary' /></ListItemIcon>
            <Typography variant='body1' color='secondary'>Sterge</Typography>
          </MenuItem>
        }

        {selectedItem && selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('undeleteRegister')}>
            <ListItemIcon className={classes.listItemIcon}><RestoreFromTrashIcon fontSize='small' color='primary' /></ListItemIcon>
            <Typography variant='body1' color='primary'>Anuleaza stergerea</Typography>
          </MenuItem>
        }
      </Menu>

      {isLoaded &&
        <Fab variant='extended' className={classes.fab}
          onClick={() => {
            setSelectedItem({
              id: '',
              register: '',
              year: '',
              lastNumber: '',
              description: '',
              idBranch: '0'
            });
            setSelectedItemOperation('editRegister');
          }}
        >
          <AddIcon className={classes.fabIcon} />
          Adauga registru
        </Fab>
      }

      {selectedItem && selectedItemOperation === 'editRegister' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'editRegister'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>{selectedItem.name ? selectedItem.name : 'Adaugare registru nou'}</DialogTitle>
          <DialogContent>
            <DialogContentText component='div'>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required select
                    label='Punct de lucru'
                    placeholder='Punct de lucru'
                    name='idBranch'
                    value={selectedItem.idBranch}
                    onChange={handleSelectedItemChange}
                  >
                    <MenuItem key='0' value='0'>Toate punctele de lucru</MenuItem>
                    {data.branches.map(option => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.branch}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required autoComplete='off'
                    label='Nume registru'
                    placeholder='Nume registru'
                    name='register'
                    value={selectedItem.register}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required autoComplete='off'
                    label='Valabil pentru anul'
                    placeholder='Valabil pentru anul'
                    name='year'
                    value={selectedItem.year}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required autoComplete='off'
                    label='Ultimul numar alocat'
                    placeholder='Ultimul numar alocat'
                    name='lastNumber'
                    value={selectedItem.lastNumber}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField margin='none' multiline rows={3}
                    label='Observatii'
                    placeholder='Observatii'
                    name='description'
                    value={selectedItem.description}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <Divider className={classes.divider} />
            <Warning display='block' style={{visibility: selectedItemWarning ? 'visible' : 'hidden'}}>{selectedItemWarning}</Warning>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded || Boolean(selectedItemWarning)} color='primary' onClick={handleEditRegister}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'deleteRegister' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'deleteRegister'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Marcati acest registru ca sters?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe STERGE doar daca sunteti sigur ca doriti sa stergeti acest registru.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='secondary' onClick={handleDeleteRegister}>
              Sterge
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'undeleteRegister' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'undeleteRegister'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Anulati marcarea acestui registru ca sters?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe DA doar daca sunteti sigur ca doriti sa anulati stergerea acestui registru..</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleUndeleteRegister}>
              DA
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Container>
  );
}